import apiFetch, { defaultApiFetchErrorHandler } from '@scale/frontend-lib/api-fetch';

export async function cloneToTest(taskId: string) {
  try {
    return apiFetch(null, `internal/lidar/${taskId}/clone_to_test`, { method: 'POST' });
  } catch (e) {
    defaultApiFetchErrorHandler(e, { handleHttp: true });
    throw e;
  }
}

type TrackEventParams = {
  event: string;
  name: string;
  timestamp: string;
};

// Store batched events for the last project
let lastSubtaskId: string | null = null;
let batchedEventValues: string[] = [];

export async function trackBatchedEventsValuesBySubtaskId(
  params: TrackEventParams & { subtaskId?: string } & $FIXME,
) {
  const subtaskId = params.subtaskId || 'unknown';
  const { value } = params;

  // If subtask changed, or batch is already large, send previous batch and clear it
  if (lastSubtaskId !== subtaskId || batchedEventValues.length > 4) {
    batchedEventValues = []; // Clear the batch
  }

  // Update project and add current event to batch
  lastSubtaskId = subtaskId;
  batchedEventValues.push(value);
}
